module.exports = __webpack_public_path__ + "img/04.3d7f1893.jpg";